/*
    Add here your own custom javascript
*/
document.addEventListener('DOMContentLoaded', function() {
  // HTML osztály javítása
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');
  
  // Hamburger menü eseménykezelő hozzáadása
  var menuButton = document.querySelector('a[href="#offcanvas-menu"]');
  if (menuButton) {
    menuButton.addEventListener('click', function(e) {
      e.preventDefault();
      var menu = document.querySelector('#offcanvas-menu');
      if (menu) menu.classList.toggle('show');
    });
  }
});
